import React from 'react'
import TermsSection from './TermsSection'

function MainContent() {
   return (
      <div>
         <div className='w-full flex flex-col items-center dark:bg-dark-2'>
            <h1 className="text-2xl md:text-3xl font-semibold leading-snug md:leading-normal mb-4 text-dark-1
         dark:text-white">
               Terms & Conditions
            </h1>
            <span className='font-sans text-gray-600 dark:text-gray-300'>
               We’re on a mission to deliver engaging, curated courses at a reasonable price.
            </span>
         </div>
         <TermsSection />
      </div>
   )
}

export default MainContent